export default {
    actions: { viewAll: "View All", close: "Close", add: "Add", buyAgain: "Buy Again", retry: "Try Again" },
    status: { loading: "Loading…", error: "Something went wrong" },
    accessibility: { openMenu: "Open menu", close: "Close", increaseQuantity: "Increase quantity", decreaseQuantity: "Decrease quantity", quickAdd: "Quick add to cart" }
} as const;
